import Splide from "@splidejs/splide";
import "@splidejs/splide/css";

function escapeHtml(text) {
  if (!text) return "";
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

function createSlideHTML(caseData) {
  const escapedTitle = escapeHtml(caseData.title);
  const escapedUrl = escapeHtml(caseData.url);
  const escapedDescription = caseData.description
    ? escapeHtml(caseData.description)
    : "";
  const escapedImageUrl = caseData.preview_image
    ? escapeHtml(caseData.preview_image)
    : "";
  const escapedLogoUrl = caseData.logo ? escapeHtml(caseData.logo) : "";

  const imageHTML = escapedImageUrl
    ? `<img class="case-slider__image" src="${escapedImageUrl}" alt="${escapedTitle}">`
    : "";
  const logoHTML = escapedLogoUrl
    ? `<img class="case-slider__logo" src="${escapedLogoUrl}" alt="Логотип">`
    : "";
  const descriptionHTML = escapedDescription
    ? `<p class="case-slider__description">${escapedDescription}</p>`
    : "";

  return `
    <li class="splide__slide">
      <div class="case-slider__card">
        <div class="case-slider__image-wrapper">
          <a href="${escapedUrl}" class="case-slider__image-link">
            ${imageHTML}
          </a>
          ${logoHTML}
        </div>
        <div class="case-slider__content">
          <a href="${escapedUrl}" class="case-slider__title-link">
            <h3 class="case-slider__card-title">${escapedTitle}</h3>
          </a>
          ${descriptionHTML}
          <a href="${escapedUrl}" class="case-slider__button btn_primary">
            Подробнее
          </a>
        </div>
      </div>
    </li>
  `;
}

function initCaseSlider(sliderContainer) {
  if (!sliderContainer) {
    console.warn("CaseSlider: sliderContainer not found");
    return;
  }

  // Проверяем, не инициализирован ли уже этот слайдер
  if (sliderContainer.dataset.initialized === "true") {
    console.log("CaseSlider: already initialized");
    return;
  }

  const caseSliderSection = sliderContainer.closest(".case-slider");
  if (!caseSliderSection) {
    console.error("CaseSlider: case-slider section not found");
    return;
  }

  // Получаем данные из script тега
  const dataScript = caseSliderSection.querySelector("[data-case-slider-data]");
  if (!dataScript) {
    console.error("CaseSlider: data script not found");
    return;
  }

  let casesData;
  try {
    casesData = JSON.parse(dataScript.textContent);
  } catch (e) {
    console.error("CaseSlider: Failed to parse case slider data", e);
    return;
  }

  if (!casesData.cases || casesData.cases.length === 0) {
    console.warn("CaseSlider: No cases data found");
    return;
  }

  console.log(`CaseSlider: Initializing with ${casesData.cases.length} cases`);

  // Генерируем структуру слайдера
  const splideHTML = `
    <div class="splide">
      <div class="splide__track">
        <ul class="splide__list">
          ${casesData.cases.map(createSlideHTML).join("")}
        </ul>
      </div>
    </div>
  `;

  sliderContainer.innerHTML = splideHTML;

  const sliderElement = sliderContainer.querySelector(".splide");
  if (!sliderElement) {
    console.error("CaseSlider: sliderElement not found after HTML injection");
    return;
  }

  const slides = sliderElement.querySelectorAll(".splide__slide");
  if (slides.length === 0) {
    console.error("CaseSlider: No slides found");
    return;
  }

  console.log(`CaseSlider: Found ${slides.length} slides`);

  const prevBtn = caseSliderSection.querySelector(".case-slider__arrow--prev");
  const nextBtn = caseSliderSection.querySelector(".case-slider__arrow--next");
  const paginationContainer = caseSliderSection.querySelector("[data-case-slider-pagination]");

  if (!prevBtn || !nextBtn) {
    console.error("CaseSlider: Navigation buttons not found", { prevBtn, nextBtn });
    return;
  }

  console.log("CaseSlider: Buttons found, initializing Splide");

  // Инициализируем Splide
  // Убеждаемся что элемент не имеет data-splide атрибута с JSON
  sliderElement.removeAttribute("data-splide");

  const splideOptions = {
    type: "slide",
    perPage: 3,
    rewind: true,
    gap: "20px",
    pagination: true,
    arrows: false,
    speed: 400,
    breakpoints: {
      1200: {
        perPage: 3
      },
      768: {
        perPage: 2
      },
      480: {
        perPage: 1
      }
    },
    classes: {
      pagination: "splide__pagination case-slider__pagination",
      page: "splide__pagination__page"
    }
  };

  console.log("CaseSlider: Creating Splide instance with options:", splideOptions);
  
  let splide;
  try {
    splide = new Splide(sliderElement, splideOptions);
    console.log("CaseSlider: Splide instance created successfully");
  } catch (e) {
    console.error("CaseSlider: Error creating Splide instance:", e);
    return;
  }

  // Обновляем состояние кнопок
  const updateButtons = () => {
    if (!splide || !splide.Components) {
      return;
    }
    
    try {
      const currentPrevBtn = caseSliderSection.querySelector(".case-slider__arrow--prev");
      const currentNextBtn = caseSliderSection.querySelector(".case-slider__arrow--next");
      
      if (!currentPrevBtn || !currentNextBtn) {
        return;
      }
      
      // При rewind: true кнопки всегда активны
      if (splide.options.rewind) {
        currentPrevBtn.disabled = false;
        currentNextBtn.disabled = false;
      } else {
        currentPrevBtn.disabled = splide.index === 0;
      const end = splide.Components.Controller.getEnd();
        currentNextBtn.disabled = splide.index >= end;
      }
    } catch (e) {
      console.error("CaseSlider: Error updating buttons:", e);
    }
  };

  // Сохраняем ссылку на splide в замыкании
  let splideInstance = null;

  // Подключаем кастомные кнопки навигации через делегирование событий
  const handleNavigation = (e) => {
    const target = e.target.closest("button");
    if (!target) return;
    
    if (target.classList.contains("case-slider__arrow--prev")) {
      e.preventDefault();
      e.stopPropagation();
      console.log("CaseSlider: Prev button clicked");
      const instance = splideInstance || splide;
      if (instance && typeof instance.go === "function") {
        instance.go("<");
      } else {
        console.error("CaseSlider: splide.go not available");
      }
    } else if (target.classList.contains("case-slider__arrow--next")) {
      e.preventDefault();
      e.stopPropagation();
      console.log("CaseSlider: Next button clicked");
      const instance = splideInstance || splide;
      if (instance && typeof instance.go === "function") {
        instance.go(">");
      } else {
        console.error("CaseSlider: splide.go not available");
      }
    }
  };

  // Используем делегирование событий на уровне секции
  caseSliderSection.addEventListener("click", handleNavigation, { passive: false });
  
  // Также добавляем прямые обработчики для надежности
  prevBtn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("CaseSlider: Prev button clicked (direct)");
    const instance = splideInstance || splide;
    if (instance && typeof instance.go === "function") {
      instance.go("<");
    }
  }, { passive: false });
  
  nextBtn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("CaseSlider: Next button clicked (direct)");
    const instance = splideInstance || splide;
    if (instance && typeof instance.go === "function") {
      instance.go(">");
    }
  }, { passive: false });

  splide.on("moved", () => {
    updateButtons();
  });

  splide.on("ready", () => {
    console.log("CaseSlider: Splide ready");
    // Перемещаем пагинацию в нужный контейнер
    const pagination = sliderElement.querySelector(".splide__pagination");
    if (pagination && paginationContainer) {
      paginationContainer.appendChild(pagination);
    }
    updateButtons();
  });

  splide.on("mounted", () => {
    console.log("CaseSlider: Splide mounted");
    updateButtons();
  });

  splide.on("resize", () => {
  updateButtons();
  });

  // Сохраняем ссылку на splide
  splideInstance = splide;

  // Монтируем Splide
  try {
    splide.mount();
    console.log("CaseSlider: Splide mounted successfully");
    splideInstance = splide; // Обновляем ссылку после монтирования
  } catch (e) {
    console.error("CaseSlider: Error mounting Splide", e);
    return;
  }

  // Дополнительная инициализация после монтирования
  setTimeout(() => {
    updateButtons();
    // Проверяем что кнопки все еще работают
    const testPrevBtn = caseSliderSection.querySelector(".case-slider__arrow--prev");
    const testNextBtn = caseSliderSection.querySelector(".case-slider__arrow--next");
    if (testPrevBtn && testNextBtn) {
      console.log("CaseSlider: Buttons are still available after mount");
    }
  }, 100);

  // Помечаем контейнер как инициализированный
  sliderContainer.dataset.initialized = "true";
}

function initAllCaseSliders() {
  console.log("CaseSlider: Initializing all sliders");
  const sliderContainers = document.querySelectorAll(
    ".case-slider [data-case-slider-container]"
  );
  console.log(`CaseSlider: Found ${sliderContainers.length} slider containers`);
  sliderContainers.forEach((container, index) => {
    console.log(`CaseSlider: Initializing slider ${index + 1}`);
    initCaseSlider(container);
  });
}

export default function caseSlider() {
  console.log("CaseSlider: Module loaded, readyState:", document.readyState);
  // Ждем загрузки DOM если нужно
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      console.log("CaseSlider: DOMContentLoaded fired");
      initAllCaseSliders();
    });
  } else {
    // Если DOM уже загружен, ждем немного чтобы убедиться что все элементы на месте
    setTimeout(() => {
      initAllCaseSliders();
    }, 100);
  }
}
